import React from 'react';
import ChatNav from '../../chat/ChatNav';

export default () => (
    <div className='nav-right'>
        <div className='chat-nav-right-container'>
            <ChatNav />
        </div>
    </div>
)